import onUserUpdated from './onUserUpdated.operation';

export default {
  onUserUpdated,
};
